import React from "react";
//#region redux
//#endregion
//#region types
import {
  MultiSearchInputProps,
  NumberInputProps,
  TextInputProps,
  ToggleProps,
} from "models/propTypes/wintFormPropsTypes";
import { TranslationKeys } from "translations";
import { CommonConstants, CustomerConstants, IconDefinitionConstants } from "utils/constants";
import { StyleEnums } from "models/enums";
import { GeneralDetailsSectionProps } from "models/propTypes/customerPropTypes";
//#endregion
//#region components
import {
  HorizontalFormField,
  GroupSection,
  NumberInput,
  MultiSearchInput,
  TextInput,
  Toggle,
} from "components/common/wintForms";
import { ProgressMessage } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const GeneralDetailsSection: React.FC<GeneralDetailsSectionProps> = ({ connect, isCreate, canToggleActiveStatus }) => {
  const nameProps = connect("generalInfo.name");
  const orgNumberProps = connect("generalInfo.orgNumber");
  const alreadyExistsFieldProps = connect("alreadyExists");
  const fromRegistryFieldProps = connect("fromRegistry");

  const autogeneratedText = CustomerConstants.CustomerValuesAutogeneratedKey;
  const autogeneratedValues = fromRegistryFieldProps.value;

  return (
    <GroupSection
      header={LocalizationHelperInstance.getFormattedMessage(
        isCreate ? TranslationKeys.Invoice.ContactDetails : TranslationKeys.Common.General
      )}
      icon={IconDefinitionConstants.WInfo}
      navKey={CustomerConstants.SettingsNavKeys.General}
    >
      <HorizontalFormField<TextInputProps>
        Component={TextInput}
        {...nameProps}
        label={TranslationKeys.Common.Name}
        descriptionText={TranslationKeys.Invoice.CompanyNameHelpText}
        customMessage={
          alreadyExistsFieldProps.value
            ? {
                type: StyleEnums.DisplayType.Danger,
                message: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Errors.DuplicateCustomer),
              }
            : alreadyExistsFieldProps.value === undefined
              ? {
                  type: StyleEnums.DisplayType.Info,
                  message: (
                    <ProgressMessage>
                      {LocalizationHelperInstance.getFormattedMessage(
                        TranslationKeys.Invoice.CustomerDuplicateChecking
                      )}
                    </ProgressMessage>
                  ),
                }
              : undefined
        }
        autogeneratedText={
          autogeneratedValues && nameProps.value === autogeneratedValues?.name ? autogeneratedText : undefined
        }
      />
      <HorizontalFormField<NumberInputProps>
        Component={NumberInput}
        {...orgNumberProps}
        label={TranslationKeys.Invoice.OrganisationNumberOrPersonNumber}
        descriptionText={TranslationKeys.Invoice.OrganisationNumberHelpText}
        allowLeadingZeros
        format={CommonConstants.OrganizationNumberMask}
        autogeneratedText={
          autogeneratedValues && orgNumberProps.value === autogeneratedValues?.orgNumber ? autogeneratedText : undefined
        }
        optional
      />
      <HorizontalFormField<MultiSearchInputProps>
        Component={MultiSearchInput}
        {...connect("generalInfo.emails")}
        label={TranslationKeys.Common.Email}
        descriptionText={TranslationKeys.Common.MultipleEmailsHelpText}
        items={[]}
        freeSolo
        optional
      />
      <HorizontalFormField<NumberInputProps>
        Component={NumberInput}
        {...connect("generalInfo.phoneNumber")}
        label={TranslationKeys.Common.Phone}
        allowLeadingZeros
        format={CommonConstants.PhoneNumberMask}
        optional
      />
      <HorizontalFormField<ToggleProps>
        Component={Toggle}
        {...connect("generalInfo.active")}
        label={TranslationKeys.Common.Active}
        descriptionText={
          canToggleActiveStatus
            ? TranslationKeys.Customer.ActivateCustomerDescriptionText
            : TranslationKeys.Customer.DisableCustomerDescriptionText
        }
        disabled={!canToggleActiveStatus}
      />
    </GroupSection>
  );
};

export default GeneralDetailsSection;
